import { EventViewData } from 'components/eventView/pages/eventData';

export const KoieneEvent: EventViewData = {
    eventId: 'koiene',
    mapId: '35f0defe-58e2-4fcb-8690-3fb8965efcaf',
    guideId: '35f0defe-58e2-4fcb-8690-3fb8965efcaf'
};
